import React, { useCallback }                        from 'react';
import { connect }                                   from 'react-redux';
import { formValueSelector, reset, SubmissionError } from 'redux-form';
import { useTranslation }                            from 'react-i18next';
import DV                                            from 'ts-data-validator';

import { nowBetweenDates } from '../../../common/tools';
import { useSidebar }      from '../../providers/sidebar';
import sidebarConstants    from '../../providers/sidebar/sidebar.constants';
import { useSiteSettings } from '../../providers/siteSettings';
import { useUser }         from '../../providers/user';

import BaseSidebar from './base/BaseSidebar';
import CallMeForm  from './components/CallMeForm';

const CallMeSidebar = (props) => {
  const {
          dispatch,
          userName,
          userPhone,
          userTime,
        } = props;

  const { t } = useTranslation();
  const {
          appealTypes,
          getToken,
          appealInitialStateLoaded,
          phone,
          send,
          tokenList,
          userInitialStateLoaded,
          name: {
                  first_name,
                  last_name,
                  patronymic,
                },
        }     = useUser();
  const {
          show,
          sidebar,
          hideSidebar,
          showGratitudeModal,
          title,
        }     = useSidebar();
  const {
          data: { WORKING_TIME },
        }     = useSiteSettings();

  const showSidebar = React.useMemo(() => show && sidebar === sidebarConstants.CALL_ME_SIDEBAR, [show, sidebar]);

  const submitCallMeForm = useCallback((event, handleSubmit) => {
    event.preventDefault();

    handleSubmit((values) => {
      const {
              day,
              time,
            } = values.time;

      const validateValues = {
        ...values,
        dayCall:  day,
        timeCall: time,
        phone:    values.phone.replace(/\s*\*$/g, ''),
      };
      delete validateValues.time;

      return send(validateValues)
        .then(() => {
          dispatch(reset('CallMeForm'));
          hideSidebar();
          showGratitudeModal();
        })
        .catch((errors) => {
          throw new SubmissionError(errors);
        });
    })(event);
  }, [send, dispatch]);

  const callMeFormProps = React.useMemo(() => {
    let name = userName;

    if (!DV.isString(name)) {
      name = null;

      if (DV.isString(first_name) && DV.isString(last_name)) {
        name = `${last_name} ${first_name}`;

        if (DV.isString(patronymic)) {
          name = `${name} ${patronymic}`;
        }
      }
    }

    let props = { submitForm: submitCallMeForm };

    if (userInitialStateLoaded && appealInitialStateLoaded) {
      const { appealTypeId } = appealTypes.find((item) => item.aliasKey === 'PHONE');
      const _token           = tokenList.PHONE || null;
      props.initialValues    = {
        appealTypeId,
        aliasKey: 'PHONE',
        name,
        phone:    userPhone || phone,
        time:     userTime,
        _token,
      };
    }

    return props;
  }, [appealInitialStateLoaded, appealTypes, first_name, last_name, patronymic, phone, submitCallMeForm, tokenList, userInitialStateLoaded, userName, userPhone, userTime]);

  React.useEffect(() => {
    if (!Object.keys(tokenList)
      .includes('PHONE')) {
      getToken('PHONE');
    }
  }, []);
  return (<>
    {appealInitialStateLoaded && (<BaseSidebar open={showSidebar} customClass={'call_me_form_sideBar'}>
      {WORKING_TIME.NOTE?.FROM && WORKING_TIME.NOTE?.TO && (<>
        {nowBetweenDates(WORKING_TIME.NOTE.FROM, WORKING_TIME.NOTE.TO) && (<div className={'information'}>
          <p
            dangerouslySetInnerHTML={{ __html: WORKING_TIME.NOTE.TEXT }}
          />
        </div>)}
      </>)}
      <label className={'sideBar_label'}>
        {title ? title : t('client_weWillHelpYouChooseDoors')}
      </label>
      <p className={'sideBar_description'}>
        {t('client_ourManagerCallYou')}
      </p>
      <CallMeForm
        {...callMeFormProps}
        title={t('client_orderingConsultationByPhone')}
      />
    </BaseSidebar>)}
  </>);
};

function mapStateToProps(state) {
  const form = formValueSelector('CallMeForm');

  return {
    userName:  form(state, 'name') || null,
    userPhone: form(state, 'phone') || '',
    userTime:  form(state, 'time') || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CallMeSidebar);
